// =============================================
// NsList — lista nameserverow (mono) + przycisk "Kopiuj" (jedna linia per NS).
// =============================================
import { Button } from "@/components/ui/button";
import { Copy } from "lucide-react";
import { useToast } from "@/hooks/use-toast";

interface Props {
  ns?: string[] | null;
  /** compact = jedna linia "ns1, ns2" + ikona; pelny = kazdy NS w osobnym wierszu */
  compact?: boolean;
  copyLabel?: string;
  className?: string;
}

export const NsList = ({ ns, compact = false, copyLabel = "NS", className = "" }: Props) => {
  const { toast } = useToast();
  if (!ns?.length) return <span className="text-xs text-muted-foreground">—</span>;

  const copy = () => {
    navigator.clipboard.writeText(ns.join("\n"));
    toast({ title: "Skopiowano nameservery", description: ns.join(", ") });
  };

  if (compact) {
    return (
      <span className={`inline-flex items-center gap-1.5 ${className}`}>
        <span className="text-xs font-mono text-muted-foreground truncate" title={ns.join("\n")}>{ns.join(", ")}</span>
        <Button variant="ghost" size="sm" className="h-6 px-1.5" onClick={copy} title="Kopiuj nameservery">
          <Copy className="h-3 w-3" />
        </Button>
      </span>
    );
  }

  return (
    <div className={`space-y-1 ${className}`}>
      {ns.map((n) => <div key={n} className="font-mono text-sm p-2 rounded bg-muted/40">{n}</div>)}
      <Button variant="outline" size="sm" className="mt-1" onClick={copy}>
        <Copy className="h-3 w-3 mr-1" />Kopiuj {copyLabel}
      </Button>
    </div>
  );
};
